/**
 * ExclusiveSubscriptionsPolicyPage
 *
 * Static public page displaying the Exclusive Subscriptions Policy.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import exclusiveSubscriptionsPolicyHtml from './content/exclusiveSubscriptionsPolicy.html?raw';

export const ExclusiveSubscriptionsPolicyPage = () => {
  const { l10n } = useLocale();
  return (
    <LegalDocumentPage
      qaId="legal-exclusive-subscriptions-policy"
      title={l10n.legal.exclusiveSubscriptionsPolicy}
      htmlContent={exclusiveSubscriptionsPolicyHtml}
    />
  );
};
